import { defineMessages } from 'react-intl';

/**
 * The page head of Settings: the subtitle of each tab that has no messages file of its own, the
 * title of the API tab and the subtitle of the phone index. The other tabs keep their subtitle in
 * their own messages file (`accountMessages.subtitle` and the like).
 */
export const settingsTabHeadMessages = defineMessages({
  settings: { id: 'app.sml.breadcrumbs.settings', defaultMessage: 'Settings' },
  pageSubtitle: {
    id: 'app.sml.settings.page.subtitle',
    defaultMessage: 'Your account, your workspace and how MUSIC24 works for you.',
  },
  subscriptionSubtitle: {
    id: 'app.sml.settings.subscription.description',
    defaultMessage: 'Manage your subscription and billing.',
  },
  connectionsLabel: { id: 'app.sml.settings.tab.connections', defaultMessage: 'Connections' },
  connectionsSubtitle: {
    id: 'app.sml.settings.connections.subtitle',
    defaultMessage: 'The social accounts MUSIC24 posts to and reads numbers from.',
  },
  teamSubtitle: {
    id: 'app.sml.team.description',
    defaultMessage: 'Everyone here shares this workspace: its artists, pages and campaigns.',
  },
  setupSubtitle: {
    id: 'app.sml.setupdock.subtitle',
    defaultMessage: 'Two minutes to switch on the rest of your plan.',
  },
  apiTitle: { id: 'app.sml.settings.apiAccess.title', defaultMessage: 'API access' },
  apiSubtitle: {
    id: 'app.sml.settings.apiAccess.subtitle',
    defaultMessage:
      'Call the same chart, playlist and follow data this product runs on. Tokens are shown once, at creation.',
  },
});
